module.exports = __webpack_public_path__ + "img/product1-3.c2789085.png";